import "core-js/modules/es.array.push.js";
import { post_Json } from "@/jsUtils/nodejsRequest";
import { Product_Info } from "@/globalcfg";
export default {
  data() {
    return {
      imagelist: [{
        img: Product_Info.Origin.image_path,
        info: Product_Info.Origin
      }, {
        img: Product_Info.MicroBrick.image_path,
        info: Product_Info.MicroBrick
      }, {
        img: Product_Info.Fascinatic.image_path,
        info: Product_Info.Fascinatic
      }, {
        img: Product_Info.Memory.image_path,
        info: Product_Info.Memory
      }, {
        img: Product_Info.Energetic.image_path,
        info: Product_Info.Energetic
      }, {
        img: Product_Info.DiamondPainting.image_path,
        info: Product_Info.DiamondPainting
      }, {
        img: Product_Info.FuseBeads.image_path,
        info: Product_Info.FuseBeads
      }],
      bannerHeight: 0,
      show_more: require("@/assets/maindetail/main_show_more.jpg")
    };
  },
  mounted() {},
  // 内部方法
  methods: {
    OnProduct_click(index) {
      const productInfo = this.imagelist[index] ? this.imagelist[index].info : null;
      if (!productInfo) {
        return;
      }
      const slug = (productInfo.key || productInfo.path || '').toLowerCase();
      if (!slug) {
        return;
      }
      this.$router.push({
        path: `/product/${slug}`
      });
      this.sendStatisticData(slug);
    },
    get_product_name(index) {
      let product_info = this.imagelist[index].info;
      // 根据语言环境返回产品名称
      if (this.$i18n.locale == "en") {
        return product_info.show_name;
      } else {
        return product_info.show_name_zh;
      }
    },
    text_more_product() {
      if (this.$i18n.locale === 'en') {
        return 'Products';
      } else {
        return '更多产品';
      }
    },
    goto_more_product() {
      this.$router.push({
        path: '/product'
      });
      this.sendStatisticData('product');
    },
    //发送统计数据
    sendStatisticData(page) {
      let data = {
        "event": "product_click",
        "data": page
      };
      let stat_url = '/imageprocesshost' + '/statistic';
      post_Json(stat_url, data).then(res => {
        // 不做任何事情
      });
    }
  }
};